import { useMemo, useState } from "react";
import { Input } from "../input/input";
import styles from "./inputWithOptions.module.css";
import classNames from "classnames";


import { Text } from "../text/text";

export const InputWithOptions = ({ value, setValue, options, ...props }) => {
    const [visible, setVisible] = useState(false);

    const filteredOptions = useMemo(() => {
        return !options ? [] : options.filter((data) => {
            const trimmedData = data.trim().toLocaleLowerCase();
            const trimmedValue = value.trim().toLocaleLowerCase()
            return trimmedValue !== trimmedData && trimmedData.includes(trimmedValue);
        });
    }, [options, value]);

    return (
        <div className={styles.container}>
            <Input
                type="text"
                value={value}
                setValue={setValue}
                autoComplete="off"
                onFocus={() => setVisible(true)}
                onBlur={() => setVisible(false)}
                {...props}
            />

            {
                filteredOptions.length > 0 &&
                <div 
                    className={classNames(styles.options, { [styles.active]: visible })}
                    onMouseDown={(e) => e.preventDefault()}
                >
                    {
                        filteredOptions.map((data) => (
                            <Text as="div" variant="body" className={styles.option}
                                key={data}
                                
                                onClick={() => setValue(data)}
                            >
                                {data}
                            </Text>
                        ))
                    }
                </div>
            }
        </div>
    );
}